import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useEnsureCountry() {
  useEffect(() => {
    const ensureCountry = async () => {
      // Get current user
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      // Check if user already has country set
      const { data: profile } = await supabase
        .from("profiles")
        .select("country")
        .eq("id", user.id)
        .maybeSingle();

      if (profile?.country) return; // Already has country

      // Detect country via IP
      try {
        const cached = sessionStorage.getItem("detected_country");
        let detectedCountry = cached;

        if (!detectedCountry) {
          const res = await fetch("https://ipapi.co/json/");
          const data = await res.json();
          detectedCountry = data.country_name || null;
          if (detectedCountry) {
            sessionStorage.setItem("detected_country", detectedCountry);
          }
        }

        if (detectedCountry) {
          await supabase
            .from("profiles")
            .update({ country: detectedCountry })
            .eq("id", user.id);
        }
      } catch (error) {
        console.error("Failed to detect/save country:", error);
      }
    };

    ensureCountry();
  }, []);
}
